module.exports = "<button type=button v-link=pathObj @click=clickF class=btn><i aria-hidden=true :class=\"{ 'fa-rotate-90': directionTop}\" class=\"fa fa-angle-left fa-2x\"></i><span>{{title}}</span></button>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/back-button.vue
// module id = 352
// module chunks = 0